import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { initialize, loggedIn, hasPermission } from '@app/core/guards';
import { StockHistoryMode } from '@app/store/stock-history/models';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: initialize(),
        pathMatch: 'full',
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routing').then(({ routes }) => routes),
    },
    {
        path: '',
        canActivate: [loggedIn()],
        component: ShellComponent,
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./dashboard/dashboard.routing').then(({ routes }) => routes),
            },
            {
                path: 'profile',
                loadChildren: () => import('./profile/profile.routing').then(({ routes }) => routes),
            },
            {
                path: 'stock',
                loadChildren: () => import('./stock/stock.routing').then(({ routes }) => routes),
            },
            {
                path: 'stock-history',
                canActivate: [hasPermission('stock_transfers.read')],
                data: { mode: 'all' } satisfies { mode: StockHistoryMode },
                loadChildren: () => import('./stock-history/stock-history.routing').then(({ routes }) => routes),
            },
            {
                path: 'users',
                canActivate: [hasPermission('users.read')],
                loadChildren: () => import('./users/users.routing').then(({ routes }) => routes),
            },
            {
                path: 'divisions',
                canActivate: [hasPermission('divisions.read')],
                loadChildren: () => import('./divisions/divisions.routing').then(({ routes }) => routes),
            },
            {
                path: 'departments',
                canActivate: [hasPermission('departments.read')],
                loadChildren: () => import('./departments/departments.routing').then(({ routes }) => routes),
            },
            {
                path: 'warehouses',
                canActivate: [hasPermission('warehouses.read')],
                loadChildren: () => import('./warehouses/warehouses.routing').then(({ routes }) => routes),
            },
            {
                path: 'roles',
                canActivate: [hasPermission('roles.read')],
                loadChildren: () => import('./roles/roles.routing').then(({ routes }) => routes),
            },
            {
                path: 'materials',
                canActivate: [hasPermission('materials.read')],
                loadChildren: () => import('./materials/materials.routing').then(({ routes }) => routes),
            },
            {
                path: 'elements',
                canActivate: [hasPermission('elements.read')],
                loadChildren: () => import('./elements/elements.routing').then(({ routes }) => routes),
            },
            {
                path: 'storytelling',
                loadChildren: () => import('./storytelling/storytelling.routing').then(({ routes }) => routes),
            },
            {
                path: '**',
                loadChildren: () => import('@error/not-found').then(({ routes }) => routes),
            },
        ],
    },
];
